import { Pipe, PipeTransform } from '@angular/core';
import { CELL_WIDTH } from '@app/modules/calendar/constants';
import { differenceInCalendarDays, isBefore } from 'date-fns';

@Pipe({
  standalone: false,
  name: 'eventOffset',
})
export class EventOffsetPipe implements PipeTransform {
  transform(event: { start_date: string }, calendarStartDate: Date): unknown {
    // if the event starts before the calendar start, the event is being generated by
    // the start of the calendar date cell. We offset it to the left so that it is in the right spot.
    if (isBefore(event.start_date, calendarStartDate)) {
      const dayDiff = differenceInCalendarDays(calendarStartDate, event.start_date);
      return -(dayDiff * CELL_WIDTH - 2);
    }

    return null;
  }
}
